import createPathMatcher from 'path-match';
import { Routing } from '@/constants';
export const getModelManagerPathMatcher = () => createPathMatcher({ end: false })(Routing.MODEL_MANAGER_PATH);
